import { render } from "./list-gateway.vue?vue&type=template&id=59865021&scoped=true"
import script from "./list-gateway.vue?vue&type=script&lang=js"
export * from "./list-gateway.vue?vue&type=script&lang=js"

import "./list-gateway.vue?vue&type=style&index=0&id=59865021&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59865021"]])

export default __exports__